<template>
    <v-expansion-panel>
      <v-expansion-panel-header>
        Agregar módulo de plantilla
        <template v-slot:actions>
          <v-icon color="primary" @click.native.stop="reloadp++">
            mdi-refresh
          </v-icon>
          <v-icon
            color="error"
            @click="$store.dispatch('deleteWindowByUuid', { uuid: win.uuid })"
          >
            mdi-close
          </v-icon>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content >
        <v-card>
          <v-tabs v-model="tab" dark background-color="primary" icons-and-text>
            <v-tabs-slider color="red"></v-tabs-slider>
  
            <v-tab href="#tab-1">
                Agregar módulo de plantilla
              <v-icon>mdi-plus</v-icon>
            </v-tab>
          </v-tabs>
  
          <v-tabs-items v-model="tab">
            <v-tab-item value="tab-1">
              <v-card class="white" flat>
                <v-card-text class="email-wrapper">
                  <v-card-text>
                    <ManageTemplateModule :key="reloadp" :win="win" :TM="TM" :editMood="false"></ManageTemplateModule>
                  </v-card-text>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </template>
  
  <script>
  import ManageTemplateModule from "./manageTempateModule.vue";
  
  export default {
    name: "AddTemplateModule",
    components: {
        ManageTemplateModule,
    },
    props: ["win"],
    data: () => ({
      TM: {
        Name: "",
        Body: {},
        Id: "",
        ID_User: "",
        State: "",
        Type: ""
      },
      tab: null,
      reloadp: 0,
    }),
    methods: {
      reloadData(payload) {
        this.$emit("reloadData", payload);
      },
    },
  };
  </script>
  
  <style scoped></style>
  